const inOutserviceName = "/InOut";

export function inOutService(http) {
    return {        
        getUserDailyInOutInfo: (data) => {
            return http.get(inOutserviceName + "/DailyInOut", data)
        },
        getDailyInOutRangeAsync : async (userId, selfPersonnelCode, personnelCode, from, to, costCenterCode) => {
            let param = {
                userId,
                selfPersonnelCode,
                personnelCode,
                from,
                to,
                costCenterCode
            }
            return await http.post(inOutserviceName + "/DailyInOutRangeAsync", param);
        },
        getExcelExportDailyInOutRangeAsync : async (userId, selfPersonnelCode, personnelCode, from, to, costCenterCode) => {
            let param = {
                userId,
                selfPersonnelCode,
                personnelCode,
                from,
                to,
                costCenterCode
            }
            return await http.post(inOutserviceName + "/ExcelExportDailyInOutRangeAsync", param, { responseType: "blob" });
        }        
    }
}
